import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import ReactDOM from 'react-dom'
import { Link, useHistory } from 'react-router-dom'

export default function SettingsContainer(props) {
  const [unlinking, setUnlinking] = useState(false)
  const [mounted, setMounted] = useState(false)
  const history = useHistory()

  const onBack = () => {
    props.screenContainerRef.current.classList.add('out')
    setTimeout(() => {
      history.push('/mobile/profile')
    }, 400)
  }

  const onUnlink = async () => {
    setUnlinking(true)
    try {
      await props.onUnlinkDevices()
    } catch (err) {
      setUnlinking(false)
      alert(err)
      return
    }
    if (!mounted) return
    history.push('/mobile/profile')
  }

  useEffect(() => {
    setMounted(true)
    return () => {
      setMounted(false)
    }
  }, [])

  return (
    <div
      className="screen settings"
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <div className="navigation-bar">
        <div className="button-item back" onClick={onBack}>
          <img src={require('../images/icon_back_arrow.png')} alt="arrow" className="arrow" />
          Back
        </div>
        <div className="title">Settings</div>
      </div>
      <div style={{ height: 15 }} />
      <Link to="/mobile/welcome" className="btn black block small">
        Revisit Instructions
      </Link>
      <div style={{ height: 25 }} />
      <a
        href={`${process.env.REACT_APP_BASE_URL}/api/mobile/me/redirect-to-baseline-evaluation`}
        className="btn black block small"
      >
        Update Baseline Evaluation
      </a>
      <div style={{ height: 25 }} />
      <a onClick={onUnlink} className="btn black block small">
        {unlinking ? 'Unlinking...' : 'Unlink Fitness Devices'}
      </a>
      <div style={{ height: 25 }} />

      <div style={{ flex: 1 }} />
      <div style={{ height: 25 }} />
      <div className="terms_block">
        <a 
        className="black"
        target="_blank"
        href={`${process.env.REACT_APP_BASE_URL}/download/terms?external=true`} >
          Terms of Service
        </a>
      </div>

      <a
        onClick={props.onLogout}
        className="btn black block small"
        style={{ background: '#FFDDDD' }}
      >
        Log Out
      </a>
    </div>
  )
}
